import { all } from "redux-saga/effects";

import appSaga from "features/app/store/saga";
import authSaga from "features/auth/store/saga";
import PrivateChatSaga from "features/private-chat/store/saga";
import SystemConfigSaga from "features/system-config/store/saga";
import UserManagementSaga from "features/user-management/store/saga";
import DocumentManagementSaga from "features/document-management/store/saga";
import PermissionManagementSaga from "features/permission-management/store/saga";
import HistoryManagementSaga from "features/history-chat/store/saga";
import CrawlingURLSaga from "features/crawling/store/saga";
import SecurityMonitoringSaga from "features/security-monitoring/store/saga";

export default function* rootSaga() {
  yield all([
    appSaga(),
    authSaga(),
    PrivateChatSaga(),
    SystemConfigSaga(),
    UserManagementSaga(),
    DocumentManagementSaga(),
    PermissionManagementSaga(),
    HistoryManagementSaga(),
    CrawlingURLSaga(),
    SecurityMonitoringSaga()
  ]);
}
